var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "small-text" },
    [
      _c(
        "v-row",
        { staticClass: "mb-0", attrs: { "no-gutters": "" } },
        [
          _c("v-col", { attrs: { cols: "1" } }),
          _vm._l(_vm.eventDays, function(day, i) {
            return _c(
              "v-col",
              { key: i },
              [
                _c(
                  "v-card",
                  { staticClass: "pa-2", attrs: { outlined: "", tile: "" } },
                  [_vm._v(" " + _vm._s(day.heading) + " ")]
                )
              ],
              1
            )
          }),
          _c("v-responsive", { attrs: { width: "100%" } })
        ],
        2
      ),
      _vm._l(_vm.times, function(time, j) {
        return _c(
          "v-row",
          { key: j, staticClass: "mb-0", attrs: { "no-gutters": "" } },
          [
            _c(
              "v-col",
              { attrs: { cols: "1" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "pa-2 full-height",
                    attrs: { outlined: "", tile: "" }
                  },
                  [_vm._v(_vm._s(time.text))]
                )
              ],
              1
            ),
            _vm._l(_vm.eventDays, function(day, i) {
              return _c(
                "v-col",
                { key: i },
                [
                  time.value === null ||
                  (time.value >= day.timeInStartMinutes &&
                    time.value <=
                      day.timeInStartMinutes + day.timeInDurationMinutes)
                    ? _c(
                        "v-card",
                        _vm._g(
                          {
                            staticClass: "full-height",
                            class: _vm.isSelectMode ? "select-mode" : "",
                            attrs: { outlined: "", tile: "" }
                          },
                          _vm.isSelectMode
                            ? {
                                click: () => _vm.handleSelectClick(day.id, time)
                              }
                            : {}
                        ),
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-stretch full-height" },
                            [
                              _vm.showMonsterSlots
                                ? _c(
                                    "div",
                                    {
                                      class: `monsterSlot monsterSlot-border-${
                                        _vm.$vuetify.theme.dark
                                          ? "dark"
                                          : "light"
                                      }`
                                    },
                                    [
                                      _c("monster-slot-marker", {
                                        attrs: {
                                          markerData: _vm.getMonsteSlotDataForTime(
                                            day.id,
                                            time.value
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticStyle: { width: "100%" } },
                                [
                                  _vm._l(
                                    _vm.getPlaceHoldersDataForTime(
                                      day.id,
                                      time.value
                                    ),
                                    function(data, k) {
                                      return _c(
                                        "div",
                                        _vm._g(
                                          {
                                            key: k,
                                            staticClass: "place-holder"
                                          },
                                          _vm.readOnly
                                            ? {}
                                            : {
                                                click: () =>
                                                  _vm.handleAddClick(
                                                    day.id,
                                                    time,
                                                    data.encounterType
                                                  )
                                              }
                                        ),
                                        [_vm._v(" " + _vm._s(data.text) + " ")]
                                      )
                                    }
                                  ),
                                  _vm._l(
                                    _vm.getSlotDataForTime(day.id, time.value),
                                    function(data, k) {
                                      return _c(
                                        "div",
                                        {
                                          key: k,
                                          staticClass:
                                            "encounter-link-container"
                                        },
                                        [
                                          data.statusId !== undefined
                                            ? _c("approval-status", {
                                                attrs: { status: data.statusId }
                                              })
                                            : _vm._e(),
                                          _vm.readRouteName && !_vm.readOnly
                                            ? _c(
                                                "router-link",
                                                {
                                                  staticClass: "encounter-link",
                                                  attrs: {
                                                    to: {
                                                      name: _vm.readRouteName,
                                                      params: { id: data.id }
                                                    },
                                                    title: data.text
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(data.text) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(_vm._s(data.text))
                                              ])
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              ),
                              !_vm.readOnly
                                ? _c("v-hover", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ hover }) {
                                            return _c(
                                              "div",
                                              {
                                                class: `${
                                                  hover ? "active-card" : ""
                                                }`,
                                                staticStyle: {
                                                  "min-width": "30px",
                                                  height: "100%"
                                                }
                                              },
                                              [
                                                !_vm.isSelectMode
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "hidden-button mt float-right",
                                                        class: `${
                                                          hover
                                                            ? "show-button"
                                                            : ""
                                                        }`,
                                                        attrs: {
                                                          icon: "",
                                                          dark: "",
                                                          small: "",
                                                          color: "green"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleAddClick(
                                                              day.id,
                                                              time
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { dark: "" }
                                                          },
                                                          [_vm._v(" mdi-plus ")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _c("v-card", {
                        staticClass: "pa-2 full-height",
                        attrs: {
                          outlined: "",
                          tile: "",
                          color: _vm.$vuetify.theme.dark
                            ? "blue-grey darken-2"
                            : "grey lighten-2"
                        }
                      })
                ],
                1
              )
            }),
            _c("v-responsive", { attrs: { width: "100%" } })
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }